import React, { Component } from 'react';
import { Icon, Form } from 'semantic-ui-react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { caseInsensitiveFilter, dateSortMethod } from 'Common/GridHelper';
import { CreateEditPhysicalEnum, FilterEnum, ItemEnum } from 'Common/FieldEnum';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { CREATE_EDIT_PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { TabDisabledInput } from 'Common/FormHelper';
import { ToolTipComponent } from 'Components';
import { PACK_SIZE_MESSAGE } from 'Common/Constants/inventory';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';

import { filterDataSource } from '../../helper';
import * as Selectors from '../../state/CreateEditPhysical/selectors';

class PhysicalItemsInfoContainer extends Component {
  static propTypes = {
    filterDataSource: PropTypes.func.isRequired,
    physicalItemsInfo: PropTypes.array,
    dataSource: PropTypes.array,
    isPreviewPage: PropTypes.bool,
    onResetPageOnDataChange: PropTypes.func,
    resetPageOnDataChange: PropTypes.bool,
    fetchSiteWarningDataLoading: PropTypes.bool,
  };
  static defaultProps = {
    physicalItemsInfo: [],
    dataSource: [],
    isPreviewPage: true,
    onResetPageOnDataChange: () => {},
    resetPageOnDataChange: true,
    fetchSiteWarningDataLoading: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      isPreferenceDataChange: false,
      columns: [
        {
          Header: () => {
            return (
              <span>
                Item <br />
                Code
              </span>
            );
          },
          visibilityName: 'Item Code',
          accessor: ItemEnum.ItemCode,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Description',
          accessor: ItemEnum.Description,
          ...ReactTableWrapperColumnProperties,
          width: 200,
        },
        {
          Header: () => {
            return (
              <ToolTipComponent
                label={'Pack Size'}
                popMessage={PACK_SIZE_MESSAGE}
                iconName="question circle outline"
              />
            );
          },
          visibilityName: 'Pack Size',
          accessor: ItemEnum.QtyPerUnit,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Kitchen Item',
          accessor: ItemEnum.PrepareInHouse,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Item Packaging',
          accessor: ItemEnum.ItemPackaging,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: () => {
            return (
              <span>
                Purchase
                <br />
                Qty
              </span>
            );
          },
          visibilityName: 'Purchase Qty',
          accessor: ItemEnum.PriQty,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          Cell: ({ original }) => {
            return (
              <EditableLabel
                label={
                  original[ItemEnum.PriQty] === null
                    ? ''
                    : original[ItemEnum.PriQty]
                }
                labelClassName={'qtyLabel'}
                refData={original}
                inputType={'text'}
                onChange={this.handleChangePriQty}
                allowEdit={true}
                disabled={props.disabled}
              />
            );
          },
          Filter: TabDisabledInput,
          visibility: false,
        },
        {
          Header: 'Unit',
          accessor: ItemEnum.Unit,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: () => {
            return (
              <span>
                Pack <br />
                Qty
              </span>
            );
          },
          visibilityName: 'Pack Qty',
          accessor: ItemEnum.SecQty,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          Cell: ({ original }) => {
            return (
              <EditableLabel
                label={
                  original[ItemEnum.SecQty] === null
                    ? ''
                    : original[ItemEnum.SecQty]
                }
                labelClassName={'qtyLabel'}
                refData={original}
                inputType={'text'}
                onChange={this.handleChangeSecQty}
                allowEdit={true}
                disabled={props.disabled}
                showCalc={true}
              />
            );
          },
        },
        {
          Header: 'Pack Unit',
          accessor: ItemEnum.SecondaryUnit,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Alternate Item',
          accessor: ItemEnum.AlternateItemId,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Account Category',
          accessor: ItemEnum.AccountCategory,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Distributor',
          accessor: ItemEnum.VendorName,
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: TabDisabledInput,
        },
        {
          Header: 'Bid Group',
          accessor: ItemEnum.BidGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Tax Group',
          accessor: ItemEnum.TaxGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Distributor Item',
          accessor: ItemEnum.VendorItem,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Brand',
          accessor: ItemEnum.CurrentBrand,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'UPC',
          accessor: ItemEnum.UPC,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'GTIN',
          accessor: ItemEnum.GTINNumber,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Begin Date',
          accessor: ItemEnum.BeginDate,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'End Date',
          accessor: ItemEnum.EndDate,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Servings Per Purchase Unit',
          accessor: ItemEnum.ServingsPerPrimaryUnit,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Menu Costing',
          accessor: ItemEnum.MenuCosting,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Order Preference',
          accessor: ItemEnum.OrderPreference,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Storage Location',
          accessor: ItemEnum.StorageLocation,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Minimum Par Level',
          accessor: ItemEnum.MinimumParLevel,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: TabDisabledInput,
        },
        {
          Header: 'Maximum Par Level',
          accessor: ItemEnum.MaximumParLevel,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
          show: false,
          Filter: TabDisabledInput,
        },
        {
          Header: 'Truck Route',
          accessor: ItemEnum.TruckRoute,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            return (original[ItemEnum.SecQty] ||
              original[ItemEnum.SecQty] === 0 ||
              (original[ItemEnum.PriQty] || original[ItemEnum.PriQty] === 0)) &&
              !props.disabled ? (
              <Icon
                name={'minus circle'}
                className={''}
                style={{
                  cursor: 'pointer',
                }}
                onClick={
                  props.disabled
                    ? () => {}
                    : () => {
                        this.handleRemoveItem(original);
                      }
                }
              />
            ) : (
              <span />
            );
          },
        },
      ],
      filterValues: {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.SiteId]: 0,
      },
    };
  }
  handleRemoveItem = original => {
    const currentFields = _.cloneDeep(this.props.input.value);
    _.remove(currentFields, item => {
      return original.ItemCode === item.ItemCode;
    });
    this.props.input.onChange(currentFields);
  };

  handleChangeSecQty = (refData, newValue, defaultValue) => {
    this.handleChangeQty(refData, newValue, ItemEnum.SecQty, defaultValue);
  };

  handleChangePriQty = (refData, newValue, defaultValue) => {
    this.handleChangeQty(refData, newValue, ItemEnum.PriQty, defaultValue);
  };

  handleChangeQty = (refData, newValue, Qty, defaultValue) => {
    let value = newValue.match(/\d{0,6}(\.\d{0,4})?/)[0];
    if (!value && newValue) {
      value = defaultValue;
    }
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue.ItemCode === refData.ItemCode;
    });
    const primOrSecQty =
      (Qty === ItemEnum.PriQty) ? ItemEnum.SecQty : ItemEnum.PriQty;
    if (index > -1) {
      if (value && value.trim().length) {
        formValues[index][Qty] = value;
      } else if (
        refData[primOrSecQty] !== null ||
        (refData[primOrSecQty] && !refData[primOrSecQty].toString())
      ) {
        if (this.props.isPreviewPage) {
          formValues[index][Qty] = value;
        } else {
          _.remove(formValues, field => {
            return field.ItemCode === refData.ItemCode;
          });
        }
      } else {
        formValues[index][Qty] = value;
      }
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[Qty] = value;
      if (value.trim().length) {
        formValues.push(newFiled);
      }
    }
    this.props.input.onChange(formValues);
  };

  prepareTableData = () => {
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [ItemEnum.ItemCode]: item[ItemEnum.ItemCode],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][ItemEnum.PriQty] = dataRow[ItemEnum.PriQty];
          dataSourceCopy[index][ItemEnum.SecQty] = dataRow[ItemEnum.SecQty];
        }
      });
    }
    return dataSourceCopy;
  };

  getTrProps = (state, rowInfo) => {
    let selected = false;
    if (
      rowInfo &&
      rowInfo.original &&
      ((rowInfo.original[ItemEnum.PriQty] !== null &&
        rowInfo.original[ItemEnum.PriQty] !== '') ||
        (rowInfo.original[ItemEnum.SecQty] !== null &&
        rowInfo.original[ItemEnum.SecQty] !== ''))
    ) {
      selected = true;
    }
    return {
      style: {
        color: selected && !this.props.disabled ? '#df5a17' : '',
        fontWeight: selected && !this.props.disabled ? '600' : '500',
      },
    };
  };

  render() {
    const {
      fetchPhysicalItems,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fetchingPhysicalOnHand,
      onResetPageOnDataChange,
      resetPageOnDataChange,
      fetchSiteWarningDataLoading,
    } = this.props;

    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          loading={
            fetchPhysicalItems ||
            gridPreferenceLoading ||
            gridPreferenceSubmitting ||
            fetchingPhysicalOnHand ||
            fetchSiteWarningDataLoading
          }
          data={this.prepareTableData()}
          reactTableRef={this.reactTable}
          resizable={true}
          defaultFilterMethod={caseInsensitiveFilter}
          noDataText={fetchPhysicalItems ? '' : 'No items found'}
          draggableColumns={true}
          showHideColumn={true}
          menu={'hasCogs'}
          saveState={{
            tableName: TableNamesEnum.PHYSICAL_LIST_CREATE_EDIT_TABLE,
          }}
          getTrProps={this.getTrProps}
          columns={this.state.columns}
          savePreference={this.onSaveGridPreferenceClick}
          onResetPageOnDataChange={onResetPageOnDataChange}
          resetPageOnDataChange={resetPageOnDataChange}
          gridName={GridEnum.INV_Physical_CreateEdit_View}
        />
      </Form.Field>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_PHYSICAL_FORM_NAME);
const mapStateToProps = state => {
  return {
    physicalItemsInfo: selector(state, [
      CreateEditPhysicalEnum.PhysicalItemsInfo,
    ]),
    gridPreferenceData: GridPreferenceSelectors.getPreferenceJson(state),
    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),
    gridPreferenceSubmitted: GridPreferenceSelectors.getSubmitted(state),
    fetchingPhysicalOnHand: Selectors.getFetchingPhysicalOnHand(state),
  };
};

export const PhysicalItemsInfo = connect(
  mapStateToProps,
  {
    filterDataSource,
  }
)(PhysicalItemsInfoContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/containers/createEditPhysical/PhysicalItemsInfo.js